export default __webpack_public_path__ + "static/media/L_draw.66a4ead5.PNG";